import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';
import {AgentInformation} from 'ApplicationEntry/models/AgentInformation';
import {AgentList} from 'ApplicationEntry/models/AgentList';
import * as A from '../models/AgentList';
import * as I from 'immutable';

export enum AgentListActionType {
  ADD_AGENT = 'agent/ADD_AGENT',
  REMOVE_AGENT = 'agent/REMOVE_AGENT',
  REMOVE_AGENTS = 'agent/REMOVE_AGENTS',
  UPDATE_AGENT_LIST = 'agent/UPDATE_AGENT_LIST',
}

export const addAgent = (agentInformation: AgentInformation) =>
  createAction(AgentListActionType.ADD_AGENT, {agentInformation});

export const removeAgent = (index: number) => {
  return createAction(AgentListActionType.REMOVE_AGENT, {index});
};

export const removeAgents = (agents: I.List<AgentInformation>) => {
  return createAction(AgentListActionType.REMOVE_AGENTS, {agents});
};

export const updateAgent = (agentInformation: AgentInformation, index: number) => {
  return createAction(AgentListActionType.UPDATE_AGENT_LIST, {agentInformation, index});
};

export type AgentListAction =
  | ReturnType<typeof addAgent>
  | ReturnType<typeof removeAgent>
  | ReturnType<typeof removeAgents>
  | ReturnType<typeof updateAgent>;

export const isAgentListAction = (action: any): action is AgentListAction =>
  action.type in reverseEnum(AgentListActionType);

type AgentListState = AgentList;
const DEFAULT_STATE: AgentListState = A.EmptyAgentList;

export default (state: AgentListState = DEFAULT_STATE, action: AgentListAction): AgentListState => {
  switch (action.type) {
    case AgentListActionType.ADD_AGENT:
      const {agentInformation} = action.payload;
      return A.addAgent(agentInformation)(state.agentList);
    case AgentListActionType.REMOVE_AGENT:
      return A.removeAgent(action.payload.index)(state.agentList);
    case AgentListActionType.REMOVE_AGENTS:
      return A.removeAgents(action.payload.agents)(state.agentList);
    case AgentListActionType.UPDATE_AGENT_LIST:
      return A.updateAgent(action.payload.agentInformation, action.payload.index)(state.agentList);
    default:
      return state;
  }
};
